module.exports = {
    resourceBaseUrl: "http://official-website-assets.itrax.cn",
};
